import {  callApiPost, callApiGet } from "./apiUtils";
const url_base = "/access";

export const getAllUsersApi = async () => {
  return await callApiGet(`${url_base}/GetAllUsersDB`);
};

export const getCurrentUser = async (mail) => {
  return await callApiGet(`${url_base}/GetUserLogin/${mail}`);
};